type WorkDocumentWrapper = {
  isMasked?: boolean;
  documents?: WorkDocumentWrapperEntry[];
};

type WorkDocumentWrapperEntry = {
  documentId?: string | null;
  isAvailable?: boolean | null;
};

type WorkDocumentContainer = {
  clientPolicies?: WorkDocumentWrapper | null;
  vendorPolicies?: WorkDocumentWrapper | null;
  conflicts?: WorkDocumentWrapper | null;
};

export type WorkDocumentCleanupMode = "remove" | "markUnavailable";

export function cleanupWorkDocumentWrappers(
  container: WorkDocumentContainer | undefined | null,
  documentId: string,
  mode: WorkDocumentCleanupMode,
): boolean {
  if (!container) return false;

  const clientPoliciesChanged = cleanupWorkDocumentWrapper(container.clientPolicies, documentId, mode);
  const vendorPoliciesChanged = cleanupWorkDocumentWrapper(container.vendorPolicies, documentId, mode);
  const conflictsChanged = cleanupWorkDocumentWrapper(container.conflicts, documentId, mode);

  return clientPoliciesChanged || vendorPoliciesChanged || conflictsChanged;
}

function cleanupWorkDocumentWrapper(
  wrapper: WorkDocumentWrapper | undefined | null,
  documentId: string,
  mode: WorkDocumentCleanupMode,
): boolean {
  if (!wrapper || wrapper.isMasked || !wrapper.documents) return false;

  if (mode === "remove") {
    const previousLength = wrapper.documents.length;
    wrapper.documents = wrapper.documents.filter((document) => document.documentId !== documentId);
    return wrapper.documents.length !== previousLength;
  }

  let changed = false;
  for (const document of wrapper.documents) {
    if (document.documentId !== documentId || document.isAvailable === false) continue;
    document.isAvailable = false;
    changed = true;
  }
  return changed;
}
